export default __webpack_public_path__ + "static/media/bang.833cfc61.wav";